// GENERATED CODE - DO NOT MODIFY BY HAND
// For all changes please modify icons-generator/src/main/resources/web/groupIcons.template file first and regenerate.
import { type LazyIcon, type LazyIconsGroup } from '@DS/components/icons/icons.types'
import { svgLazyLoader } from '@Utils/icons'

const FamilyArea = svgLazyLoader('area/family_area')
const KidsArea = svgLazyLoader('area/kids_area')
const QuietArea = svgLazyLoader('area/quiet_area')

const ALL_AREA_ICONS = ['family_area', 'kids_area', 'quiet_area'] as const
export type AreaIcon = (typeof ALL_AREA_ICONS)[number]

const ICONS: LazyIconsGroup<AreaIcon> = {
  family_area: FamilyArea,
  kids_area: KidsArea,
  quiet_area: QuietArea,
}

export const isAreaIcon = (areaKey: string): areaKey is AreaIcon => ALL_AREA_ICONS.includes(areaKey as AreaIcon)

export const getAreaIcon = (areaKey: AreaIcon): LazyIcon => ICONS[areaKey]

export const getAreaIcons = (): LazyIconsGroup<AreaIcon> => ICONS
